import EmailInput from './EmailInput.vue';
import EmailInputService from './EmailInputService';

EmailInput.EmailInputService = EmailInputService;

export default EmailInput;
